import React from 'react';
import { Trans, withTranslation } from 'react-i18next';
import {
    Card,
    InternalGrid,
    Text,
    DaButton,
    ArrowLongRightIcon,
    ButtonGroup,
} from '@paygreen/paygreen-ui';
import { LogoPaygreenWithMode } from '../../assets/logos';
import { IsBigDesktop } from '../../utils/tools';
import { charityEnvLink } from '../user/shared';

const SubscriptionAlternatives = ({ t }) => {
    const cardProps = {
        colorWab: 'grey10',
        shadowSize: 'none',
        paddingLateral: 'xs',
        paddingBottom: 'xs',
        paddingTop: 'xs',
        radiusSize: 'none',
        blockWidth: 'lg',
    };

    return (
        <Card hasBackground={false} blockWidth="md">
            <InternalGrid
                displayType="grid"
                gridGap="lg"
                justifyItems="stretch"
                childrenMarginTop={IsBigDesktop() ? 'none' : 'md'}
            >
                {IsBigDesktop() && (
                    <LogoPaygreenWithMode justifyContent="flex-start" />
                )}

                <Card {...cardProps}>
                    <Text htmlTag="strong" colorWab="grey40">
                        {t(
                            'subscription.subscriptionAlternatives.alreadyClientCharity',
                        )}
                    </Text>

                    <Text textSize="xs">
                        <Trans
                            i18nKey={
                                'subscription.subscriptionAlternatives.activateSpace'
                            }
                        >
                            Activez Climate directement depuis votre page
                            <Text
                                htmlTag="strong"
                                textSize="xs"
                                style={{ fontStyle: 'italic' }}
                            >
                                {{
                                    mySpaces: t(
                                        'subscription.subscriptionAlternatives.mySpaces',
                                    ),
                                }}
                            </Text>
                            en quelques clics
                        </Trans>
                    </Text>

                    <ButtonGroup marginTop="xs" marginBottom="xs">
                        <a
                            href={charityEnvLink() + '/user/spaces'}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <DaButton
                                gradient="theme"
                                colorTheme="quaternary"
                                icon={<ArrowLongRightIcon />}
                            >
                                {t('login.button')}
                            </DaButton>
                        </a>
                    </ButtonGroup>
                </Card>
            </InternalGrid>
        </Card>
    );
};

export default withTranslation('common')(SubscriptionAlternatives);
